import api from './axiosConfig';

export const inquiriesAPI = {
  getAll: async (params = {}) => {
    const response = await api.get('/inquiries', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/inquiries/${id}`);
    return response.data;
  },

  updateStatus: async (id, status) => {
    const response = await api.put(`/inquiries/${id}`, { status });
    return response.data;
  },

  getDraft: async (id) => {
    const response = await api.get(`/inquiries/${id}/draft`);
    return response.data;
  },

  saveDraft: async (id, body, fromEmail = 'bookings') => {
    const response = await api.put(`/inquiries/${id}/draft`, { body, fromEmail });
    return response.data;
  },

  sendReply: async (id, message, fromEmail = 'bookings') => {
    const response = await api.post(`/inquiries/${id}/reply`, { message, fromEmail });
    return response.data;
  },

  sendReplyWithAttachments: async (id, formData) => {
    const response = await api.post(`/inquiries/${id}/reply`, formData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/inquiries/${id}`);
    return response.data;
  },

  bulkDelete: async (ids) => {
    const response = await api.post('/inquiries/bulk-delete', { ids });
    return response.data;
  },
};
